import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Document} from '../../../models/browseDocuments.model';
import {AnoFileNamePipe} from '../../../_pipes/ano-file-name.pipe';
import {animate, style, transition, trigger} from '@angular/animations';
import {DocTypeToken} from '../../../_services/api/file.service';

@Component({
  selector: 'app-dicom-file-item',
  templateUrl: './dicom-file-item.component.html',
  styleUrls: ['./dicom-file-item.component.scss'],
  providers: [AnoFileNamePipe],
  animations: [
    trigger('item', [
      transition(':enter', [
        style({opacity: 0, transform: 'translateX(50%)'}),
        animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ]),
      transition(':leave', [
        style({ opacity: 1}),
        animate('1s cubic-bezier(.8,-0.6,0.2,1.5)',
          style({ transform: 'translateX(-50%)', opacity: 0 }))
      ])
    ])
  ]
})
export class DicomFileItemComponent implements OnInit {
  @Input() document: Document;
  @Output() deleteDocument: EventEmitter<Document> = new EventEmitter();
  @Output() downloadDocument: EventEmitter<DocTypeToken[]> = new EventEmitter();
  @Output() shareDocument: EventEmitter<Document> = new EventEmitter<Document>();


  constructor() {
  }

  ngOnInit(): void {

  }

  delete() {
    this.deleteDocument.emit(this.document);
  }

  download() {
    const docIds: DocTypeToken[] = [
      {
        tokens: [this.document.docId], type: 'dicom'
      }
    ];
    this.downloadDocument.emit(docIds);
  }

  selectByClick(): void {
    this.document.selection.isSelected = !this.document.selection.isSelected;
  }

  share() {
    this.shareDocument.emit(this.document);
  }
}
